import { loadLocalData, saveLocalData } from '@/store/state';

const STATE_DB_KEY = 'db';

export const loadDb = _store => {
	return loadLocalData(setDb, _store, STATE_DB_KEY).then(() => {
		const db = _store.state.db;
		// for (const key in db) {
		// 	console.log(`load, db.${key}=${db[key]}`);
		// }

		return db ? true : false;
	});
};

export const saveDb = _store => {
	const db = _store.state.db;
	for (const key in db) {
		console.log(`db, savedb, db.${key}=`, db[key]);
	}
	return saveLocalData(STATE_DB_KEY, db);
};

export const setDb = (_store, _group, _db) => {
	console.log(`db, setdb, _store=,`, _store, `, _group=${_group}, _db=`, _db);
	if (!_store || !_db || _group !== 'db') {
		console.log(`db, setdb, not set, _group=${_group}, _db=`, _db);
		return false;
	}
	changeDbObject(_store, _db);
	return true;
};

// Db Module
export const resetDb = _store => {
	_store.commit('resetDb');
};

export const changeDb = (_store, _name, _value) => {
	_store.commit('changeDb', {
		name: _name,
		value: _value,
	});
};

export const deleteDb = (_store, _name) => {
	_store.commit('deleteDb', {
		name: _name,
	});
};

export const changeDbObject = (_store, _value) => {
	_store.commit('changeDbObject', {
		value: _value,
	});

	//沒有加這一行，db的值commit後不會改變，但是在store db.js裡都正常
	// _store.state.db = JSON.parse(JSON.stringify(_value));

	console.log(`db, change-db-object, db=`, _store.state.db);
};

// 讀取頁面資料
export const getCurrentEventbasic = _store => {
	loadLocalData(setDb, _store, STATE_DB_KEY);
	console.log(`db, get-current-eventbasic, `, _store.state.db.eventbasic);
	return _store.state.db.eventbasic;
};
